import Recent from './SearchResult'

export default Recent
